``<template>
  <div class="">
    <v-card-title class="mb-8 pa-0">
      Dashboard Overview
    </v-card-title>
    <v-row class="pa-0">
      <v-col cols="12" md="3">
        <router-link :to="{ name:'invoices', query: { status: $getConstInvoiceStatus('INVOICE_STATUS_CREATED') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#000000"
                >
                  mdi-receipt-text-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#000000">
                  {{ formatNumber(summary.invoice_created) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Invoice Created</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          elevation="0">
          <v-list-item three-line>
            <v-list-item-avatar class="mr-1">
              <v-icon
                large
                color="#9ECC5E"
              >
                mdi-receipt-text-plus-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="today-sales-title font-weight-bold" style="color:#9ECC5E">
                {{ formatNumber(summary.for_invoice) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">For Invoice</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <router-link :to="{ name:'invoices', query: { status: $getConstInvoiceStatus('INVOICE_STATUS_SENT') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#FCB812"
                >
                  mdi-receipt-text-arrow-right-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#FCB812">
                  {{ formatNumber(summary.invoice_sent) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Invoice Sent</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>

      <v-col cols="12" md="3">
        <router-link :to="{ name:'invoices', query: { status: $getConstInvoiceStatus('INVOICE_STATUS_PAID') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="success"
                >
                  mdi-receipt-text-check-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#4caf50">
                  {{ formatNumber(summary.invoice_paid) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Invoice Paid</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" class="pa-6 pt-4 mt-4">
          <v-card-title>
            For Invoice
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              class="table-search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details>
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="bookings"
            :server-items-length="pagination.total"
            :items-per-page="pagination.per_page"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
            :loading="loading"
            loading-text="Loading For Invoices..."
            item-key="item"
            no-data-text="No For Invoices Found"
            :options.sync="options"
            ref="table">

            <template v-slot:[`item.shipping_mark`]="{ item }">
              <v-icon
                size="24"
                class="mr-2">
                {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
              </v-icon>
              {{ item.shipping_mark }}
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              {{ formatNumber(item.qty) }}
            </template>

            <template v-slot:[`item.cbm`]="{ item }">
              <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.cbm) }} CBM</span>
              <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.kg) }} KG</span>
            </template>


            <template v-slot:[`item.sales_agent`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-1">
                  mdi-face-agent
                </v-icon>

                {{ item.sales_agent }}
              </div>
            </template>

            <template v-slot:[`item.client_name`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-2">
                  mdi-account-outline
                </v-icon>
                {{ item.client_name }}
              </div>
            </template>

            <template v-slot:[`item.sales_agent`]="{ item }">

              <v-icon
                size="24"
                class="mr-1">
                mdi-face-agent
              </v-icon>

              {{ item.sales_agent }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | moment("MM-D-YYYY") }}
            </template>


            <template v-slot:item.action="{ item }">
              <v-chip
                text-color="white"
                color="primary"
                @click="viewItem(item.id)"
              >
                <span class="pa-2">Create Delivery Order</span>
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card elevation="0" class="pa-6 pt-4 mt-4">
          <v-card-title>
            Rewards Club Royale
            <v-chip
              class="ml-3"
              text-color="white"
              small
              color="info">
              <strong>For Confirmation</strong>
            </v-chip>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchReward"
              class="table-search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details>
            </v-text-field>
          </v-card-title>

          <v-data-table
            :headers="rewardHeaders"
            :items="rewards"
            :server-items-length="rewardPagination.total"
            :items-per-page="rewardPagination.per_page"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
            :loading="rewardLoading"
            loading-text="Loading Reward For Confirmations..."
            item-key="item"
            no-data-text="No Reward For Confirmations Found"
            :options.sync="rewardOptions"
            ref="table">

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | moment("MMM D, YYYY h:mmA") }}
            </template>

            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    class="mr-2"
                    color="primary"
                    @click="editItem(item.client_slug, '')">
                    mdi-magnify
                  </v-icon>
                </template>
                <span>View</span>
              </v-tooltip>
            </template>



            <template v-slot:[`item.amount`]="{ item }">
              {{ formatNumberAmount($numeral, item.amount) }}
            </template>

            <template v-slot:[`item.points`]="{ item }">
              {{ formatNumberAmount($numeral, item.points) }}
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BookingStatusLabel from '@/components/BookingStatusLabel.vue'

export default {
  name: 'DashboardAccountant',
  data: () => ({
    accountingNamespace: 'accounting',
    firstLoad: true,
    loading: false,
    search: '',
    awaitingSearch: false,
    rewardLoading: false,
    searchReward: '',
    awaitingRewardSearch: false,
    selected: [],
    statuses: [],
    bookings: [],
    agents: [],
    summary: {
      invoice_created: 0,
      for_invoice: 0,
      invoice_sent: 0,
      invoice_paid: 0
    },
    pagination: {
      page: 1,
      per_page: 1,
      total: 0,
      next: 0
    },
    rewardPagination: {
      page: 1,
      per_page: 1,
      total: 0,
      next: 0
    },
    options: {},
    rewardOptions: {},
    rewards: [],
    rewardHeaders: [
      {
        text: 'Transaction Code',
        align: 'start',
        value: 'trans_no',
        sortable: false,
        width: 150
      },
      {
        text: 'Client Name',
        value: 'client_name',
        sortable: false
      },
      {
        text: 'Amount',
        align: 'right',
        value: 'amount',
        sortable: false
      },
      {
        text: 'Points',
        align: 'right',
        value: 'points',
        sortable: false
      },
      {
        text: 'Reference No.',
        align: 'center',
        value: 'ref_no',
        sortable: false
      },
      {
        text: 'Transaction Date',
        align: 'center',
        value: 'created_at',
        sortable: false,
        width: 180
      },
      {
        text: '',
        align: 'center',
        value: 'action',
        sortable: false
      }
    ],
    headers: [
      {
        text: 'Shipping Mark',
        align: 'start',
        value: 'shipping_mark',
        sortable: false
      },
      {
        text: 'Container',
        align: 'start',
        value: 'container',
        sortable: false
      },
      {
        text: 'Description',
        align: 'start',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Qty',
        align: 'right',
        value: 'qty',
        sortable: false,
      },
      {
        text: 'Measure',
        align: 'right',
        value: 'cbm',
        sortable: false,
      },
      {
        text: 'Client Name',
        align: 'start',
        value: 'client_name',
        sortable: false,
      },
      {
        text: 'Sales Agent',
        align: 'start',
        value: 'sales_agent',
        sortable: false,
      },
      // {
      //   text: '',
      //   value: 'action',
      //   sortable: false,
      //   width: 90
      // }
    ]
  }),

  computed: {
    ...mapGetters(['formatNumberAmount', 'formatNumber', 'forSea'])
  },
  watch: {
    options: {
      handler () {
        this.getBookings()
      },
      deep: true,
    },
    search: function (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.options.page = 1
          this.getBookings()
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
    rewardOptions: {
      handler () {
        this.getRewardForConfirmations()
      },
      deep: true,
    },
    searchReward: function (val) {
      if (!this.awaitingRewardSearch) {
        setTimeout(() => {
          this.rewardOptions.page = 1
          this.getRewardForConfirmations()
          this.awaitingRewardSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingRewardSearch = true;
    },
  },
  methods: {
    editItem (slug, editType) {
      this.$router.push({ name: 'rewards-clients-view', params: { slug: slug } })
    },
    isShipmentForSea (shipment_type){
      return this.forSea(shipment_type, this)
    },
    getAgentName: function(id){
      let agents = this.agents.filter(agent => {
        return agent.id == id
      })
      if(agents.length > 0){
        let agent = agents[0]
        return agent.first_name + ' ' + agent.last_name
      }
    },
    getStatusName: function(id){
      let statuses = this.statuses.filter(status => {
        return status.id == id
      })
      if(statuses.length > 0){
        return statuses[0].name
      }
    },
    getDefaultData () {
      let self = this
      this.$http.plain.get('/default-data?booking_statuses=true&agents=true')
        .then(response => {
          this.statuses = response.data.booking_statuses
          this.agents = response.data.agents
        })
        .catch(error => {
          console.log(error);
        })
    },
    getSummary () {
      let self = this
      this.$http.plain.get(this.accountingNamespace+'/invoices/summary')
        .then(response => {
          this.summary = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    getRewardForConfirmations () {
      if (this.rewardLoading) {
        return false
      }

      const { sortBy, sortDesc, page, itemsPerPage } = this.rewardOptions
      let sorting = []
      let params = []

      if (sortBy.length === 1 && sortDesc.length === 1) {
        sortBy.forEach(function (item, index) {
          let sort = 'ASC'
          if (!sortDesc[index]) {
            sort = 'DESC'
          }
          sorting.push(item+'='+sort)
        });
      }

      if (this.searchReward.length > 0){
        params.push('&search='+this.searchReward)
      }

      this.rewardLoading = true
      let self = this
      this.$http.plain.get(this.accountingNamespace+'/rewards/for-confirmation?page='+ page + '&per_page=' + itemsPerPage + params.join())
        .then(response => {
          this.rewards = response.data.rewards

          if (response.data.pagination) {
            let pagination = response.data.pagination

            this.rewardPagination.total = pagination.count
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(function () {
          self.rewardLoading = false
        })
    },
    viewItem (id) {
      this.$router.push({ name: 'booking-view', params: { id: id } })
    },
    getBookings () {
      if (this.loading) {
        return false
      }

      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sorting = []
      let params = []

      if (sortBy.length === 1 && sortDesc.length === 1) {
        sortBy.forEach(function (item, index) {
          let sort = 'ASC'
          if (!sortDesc[index]) {
            sort = 'DESC'
          }
          sorting.push(item+'='+sort)
        });
      }

      if (this.search.length > 0){
        params.push('&search='+this.search)
      }

      this.loading = true
      let self = this
      this.$http.plain.get(this.accountingNamespace+'/for-invoices?page='+ page + '&per_page=' + itemsPerPage + params.join())
        .then(response => {
          this.bookings = response.data.bookings

          if (response.data.pagination) {
            let pagination = response.data.pagination

            this.pagination.total = pagination.count
          }

        })
        .catch(error => {
          console.log(error);
        })
        .then(function () {
          self.loading = false
        })
      }
  },
  mounted () {
    this.getDefaultData()
    this.getSummary()
    this.getRewardForConfirmations()
  },
  components: {
    BookingStatusLabel
  },
};
</script>
